<template>
  <header class="header">
    <div class="header-container container">
      <div class="logo" @click="$router.push('/')">
        <img :src="company.logo" :alt="company.name" class="logo-img" />
        <span class="logo-text">{{ company.name }}</span>
      </div>
      <nav class="nav" :class="{ active: showMobileMenu }">
        <router-link
          v-for="item in menuItems"
          :key="item.path"
          :to="item.path"
          class="nav-link"
          @click.native="closeMobileMenu"
        >
          {{ item.name }}
        </router-link>
      </nav>

      <div class="user-area">
        <!-- <template v-if="currentUser">
          <el-dropdown trigger="click" @command="handleUserCommand">
            <span class="user-name">
              <i class="el-icon-user-solid"></i>
              {{ currentUser.username }}
              <i class="el-icon-arrow-down"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="profile">个人中心</el-dropdown-item>
              <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
        <template v-else>
          <span class="login-text" @click="goLogin">登录</span>
        </template> -->
      </div>

      <button class="mobile-menu-btn" @click="toggleMobileMenu">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>
  </header>
</template>

<script>
import { authState, logout } from '@/utils/auth.js'
import { getUserInfo } from '@/api/user'

export default {
  name: 'Header',
  props: {
    company: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showMobileMenu: false,
      menuItems: [
        { name: '首页', path: '/' },
        { name: '数字乐园', path: '/products' },
        { name: '探索方式', path: '/solutions' },
        // { name: '探索手记', path: '/news' },
        { name: '关于我们', path: '/about' },
        { name: '联系我们', path: '/contact' }
      ]
    }
  },
  computed: {
    currentUser() {
      return authState.user
    }
  },
  methods: {
    toggleMobileMenu() {
      this.showMobileMenu = !this.showMobileMenu
    },
    closeMobileMenu() {
      this.showMobileMenu = false
    },
    goLogin() {
      this.$router.push('/login')
    },
    handleUserCommand(command) {
      if (command === 'logout') {
        logout()
        this.$message.success('已退出登录')
        this.$router.push('/')
      } else if (command === 'profile') {
        this.$router.push('/users/profile')
      }
    },
    async handleTest(){
      console.log('getUserInfo',process.env)
      const res = await getUserInfo()
      console.log('res==',res)
    }
  }
}
</script>

<style scoped>
.header {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
}

.logo-img {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  object-fit: cover;
}

.logo-text {
  font-size: 20px;
  font-weight: 700;
  color: #2c3e50;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.nav {
  display: flex;
  gap: 5px;
}

.nav-link {
  padding: 10px 20px;
  font-size: 15px;
  color: #555;
  border-radius: 25px;
  transition: all 0.3s;
}

.nav-link:hover {
  color: #667eea;
  background: rgba(102, 126, 234, 0.08);
}

.nav-link.router-link-active {
  color: #fff;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.user-area {
  display: flex;
  align-items: center;
  margin-left: 20px;
}

.login-text {
  padding: 8px 22px;
  font-size: 14px;
  color: #667eea;
  border: 1px solid #667eea;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s;
  white-space: nowrap;
}

.login-text:hover {
  color: #fff;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-color: transparent;
}

.user-name {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  font-size: 14px;
  color: #555;
  cursor: pointer;
  border-radius: 20px;
  transition: all 0.3s;
  white-space: nowrap;
}

.user-name:hover {
  background: rgba(102, 126, 234, 0.08);
  color: #667eea;
}

.mobile-menu-btn {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 28px;
  height: 20px;
  background: none;
  padding: 0;
}

.mobile-menu-btn span {
  display: block;
  width: 100%;
  height: 3px;
  background: #333;
  border-radius: 2px;
  transition: all 0.3s;
}

@media (max-width: 768px) {
  .mobile-menu-btn {
    display: flex;
  }

  .nav {
    position: fixed;
    top: 70px;
    left: 0;
    width: 100%;
    flex-direction: column;
    background: #fff;
    padding: 20px;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
    transform: translateY(-100%);
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s;
  }

  .nav.active {
    transform: translateY(0);
    opacity: 1;
    visibility: visible;
  }

  .nav-link {
    padding: 15px 20px;
    border-radius: 8px;
  }

  .logo-text {
    font-size: 18px;
  }

  .user-area {
    margin-left: auto;
    margin-right: 15px;
  }

  .login-text {
    padding: 6px 14px;
    font-size: 13px;
  }

  .user-name {
    padding: 6px 10px;
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .header-container {
    height: 60px;
  }
  
  .logo-img {
    width: 38px;
    height: 38px;
  }
  
  .logo-text {
    font-size: 16px;
  }
}
</style>
